import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Observable,  ReplaySubject ,  Subject } from 'rxjs';

@Injectable()

export class CommentBoxService {
    // reply;

    private _commentId: Subject<string>;
    commentId$: Observable<string>;

    constructor() {
        this._commentId = new Subject<string>();
        this.commentId$ = this._commentId.asObservable();
    }

    notify(message: string) {
        this._commentId.next(message);
    }

    private _commentBoxService = new BehaviorSubject<any>({});
    // private _commentBoxService = new ReplaySubject<any>();
    // private _commentBoxService = new Subject<any>();
    commentBoxSource$ = this._commentBoxService.asObservable();

    showCommentBox(reply) {
        this._commentBoxService.next(reply);
    }

    clearCommentBoxReply() {
        this._commentBoxService.next({});
    }

    // markReplyAsUsed() {
    //     if (this.reply) {
    //         this.reply.used = true;
    //     }
    // }
}
